export const getTextFields = (designationData: any) => [
    {
        id: "designation",
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        capitalizedFirst: true,
        value: designationData?.name
    },
    {
        label: "Status",
        value: designationData?.enabled === true ? 'Enabled' : 'Disabled',
        formField: false,
    },
    {
        label: "Industry",
        value: designationData?.industry?.name,
        formField: false,
    },
  
];